import React from "react";
import "./Loader.css"; 

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="crypto-loader">
        <span>M</span>
        <span>I</span>
        <span>N</span>
        <span>J</span>
        <span>O</span>
        <span>K</span>
      </div>
    </div>
  );
};

export default Loader;

// import React from "react";
// import "./Loader.css"; 
// import logo from "../assets/logo.png";

// const Loader = () => {
//   return (
//     <div className="loader-container">
//       <div className="logo-loader">
//         <img src={logo} alt="Minjok Logo" className="logo-image" />
//       </div>
//     </div>
//   );
// };

// export default Loader;

